import { default as MuiTableRow, TableRowProps } from '@mui/material/TableRow'
import * as React from 'react'

const TableRow: React.FC<React.PropsWithChildren<TableRowProps>> = (props) => <MuiTableRow {...props} />

export default TableRow
